<template lang='pug'>
  script(type='application/ld+json' v-text='schema')
</template>
<script>
import sephoraLogo from '@/assets/images/home/sephora-logo.png'
import { fullUrl } from '@/modules/services/utilities'

export default {
  props: {
    images: {
      type: Array,
      default: () => [],
      required: true
    },
    title: {
      type: String,
      required: true
    },
    textSnippet: {
      type: String,
      required: true
    },
    tags: {
      type: Array,
      required: true
    },
    contentTypeName: {
      type: String,
      required: true
    },
    publishedAt: {
      type: Date,
      required: true
    }
  },

  data () {
    return {
      sephoraLogo: sephoraLogo
    }
  },

  computed: {
    rootUrl () {
      return window.config.domain
    },
    schema () {
      return {
        '@context': 'https://schema.org',
        '@type': 'Article',
        'mainEntityOfPage': {
          '@type': 'WebPage',
          '@id': `${this.rootUrl}${this.$route.fullPath}`
        },
        'headline': this.title,
        'image': this.images,
        'datePublished': this.publishedAt.toISOString(),
        'author': {
          '@type': 'Person',
          'name': 'Sephora'
        },
        'publisher': {
          '@type': 'Organization',
          'name': 'Sephora',
          'logo': {
            '@type': 'ImageObject',
            'url': fullUrl(this.sephoraLogo)
          }
        },
        'url': `${this.rootUrl}${this.$route.fullPath}`,
        'articleSection': this.contentTypeName,
        'keywords': this.tags.map(tag => tag.attributes.name),
        'description': this.textSnippet
      }
    }
  }
}
</script>
